<template>
	<div class="ui-toast">
		<transition-group name="it-fade-slide-down">
			<div v-for="(msg, i) in data.data" :key="msg.id" @click="msg.remove()" class="ui-toast-item">
				<img v-if="msg.status == 'success'" src="./assets/success.svg" />
				<img v-if="msg.status == 'error'" src="./assets/failure.svg" />
				<span>{{ msg.text }}</span>
			</div>
		</transition-group>
	</div>
</template>

<script>
import Toast from "../store/Toast";
export default {
	name: "Toast",
	props: {
		data: {type: Toast, required: true},
	},
};
</script>
<style lang="less">
.ui-toast {
	position: fixed;
	top: 50%;
	transform: translateY(-50%);
	left: 50%;
	transform: translateX(-50%);
	text-align: center;
	display: flex;
	align-items: center;
	flex-direction: column;
	z-index: 10000;
}
.ui-toast-item {
	height: 44rem;
	min-width: 200rem;
	background-color: #222222;
	cursor: pointer;
	opacity: 0.6;
	border-radius: 5rem;
	margin: 5rem;
	padding: 0rem 10rem;
	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: 20rem;
		height: 20rem;
	}
	> span {
		margin-left: 10rem;
		font-size: 16rem;
		font-weight: 400;
		color: #ffffff;
		line-height: 20rem;
	}
}
</style>
